import React, { useCallback, useEffect, useState } from "react";
import { Select } from "antd";
import { getValueFromNestedObject } from "@/Utils/Index";

const { Option } = Select;

export default function CustomSelector(props) {
  const {
    form: { values, setFieldValue },
    field: { name, options },
  } = props;
  const value = getValueFromNestedObject(values, name);
  const [inputValue, setInputValue] = useState(value);

  const handleChange = (selectedValue) => {
    setInputValue(selectedValue);
  };

  useEffect(() => {
    setFieldValue(name, inputValue);
  }, [inputValue]);

  return (
    <Select value={inputValue} onChange={handleChange} style={{ width: "100%" }} placeholder="Select an option">
      {options?.map((option) => (
        <Option key={option.value} value={option.value}>
          {option.label}
        </Option>
      ))}
    </Select>
  );
}
